import Vue from 'vue'
//兄弟组件之间进行通行
export default new Vue()
